<template>
  <div>
    <p class="main-tit">公司地址</p>
    <p class="job-address" :address="address">
      {{ address }}
    </p>
    <div class="job-map">
      <!-- map str -->
      <baidu-map class="map" :center="markerPoint" :zoom="15">
        <bm-marker
          :position="markerPoint"
          :dragging="true"
          @click="infoWindowOpen"
        >
          <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
          <bm-info-window
            :show="show"
            @close="infoWindowClose"
            @open="infoWindowOpen"
            style="font-size: 13px"
          >
            {{ address }}
          </bm-info-window>
        </bm-marker>
      </baidu-map>
      <!-- map end -->
    </div>
  </div>
</template>
<script>
export default {
  name: "Map",
  props: ["markerPoint", "address"],
  data() {
    return {
      show: false,
    };
  },
  methods: {
    // map
    infoWindowClose() {
      this.show = false;
    },
    infoWindowOpen() {
      this.show = true;
    },
  },
};
</script>
<style scoped>
.main-tit {
  position: relative;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  line-height: 22px;
  padding-bottom: 13px;
}
.main-tit::after {
  position: absolute;
  content: "";
  bottom: 0;
  left: 0;
  width: 30px;
  height: 2px;
  background: #3b87ff;
}
.job-address {
  line-height: 20px;
  margin: 22px 0 13px;
}
.map {
  width: 100%;
  height: 260px;
}
</style>
